/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './notifyOfUpdate.defs.js'
export * as $defs from './notifyOfUpdate.defs.js'
